import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Card, CardBody, Heading, Skeleton, Text } from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import useFarmsWithBalance from 'views/Home/hooks/useFarmsWithBalance'
import useGetTopPoolsByApr from 'views/Home/hooks/useGetTopPoolsByApr'
import Balance from 'components/Balance'

const StyledTotalValueLockedCard = styled(Card)`
  align-items: center;
  display: flex;
  flex: 1;
`

const TotalValueLockedCard = () => {
  const { t } = useTranslation()
  // const data = useGetStats()
  // const { earningsSum } = useFarmsWithBalance()
  // const tvl = totalValue.toFixed(2);

  const { lockedInPool } = useGetTopPoolsByApr(true)

  const [totalValue, setTotalValue] = useState(0)
  useEffect(() => {
    setTotalValue(lockedInPool)
  }, [lockedInPool])

  return (
    <StyledTotalValueLockedCard>
      <CardBody>
        <Heading scale="lg" mb="24px" color="#8B5B21">
          {t('Total Value Locked (TVL)')}
        </Heading>
        <>
          {totalValue !== undefined && totalValue !== null
            ? <Balance
              decimals={totalValue > 0 ? 3 : 0}
              fontSize="36px"
              bold
              prefix="$"
              lineHeight="1.1"
              value={totalValue}
            />
            : <Skeleton width={200} height={40} my="4px" />}
          <Text color="textSubtle">{t('Across all Pools')}</Text>
        </>
      </CardBody>
    </StyledTotalValueLockedCard>
  )
}

export default TotalValueLockedCard
